import React from 'react'
import Template from "./Template"
import { useAuth } from './Auth/AuthProvider'
import UserCheck from './Components/UserCheck/UserCheck'

function App() {
  const { loading } = useAuth()

  if (loading) {
    return <UserCheck />
  }

  return <Template />
}

export default App
